import { render } from "./TodayBadge.vue?vue&type=template&id=4dc2ffff"
import script from "./TodayBadge.vue?vue&type=script&lang=js"
export * from "./TodayBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__